// removed by extract-text-webpack-plugin
module.exports = {"container":"_39R8f6hIS4sTje9dNzKKaV","grid":"_12RU0EmK0TW6L8hgUGebIW","formula":"-PXJNzuIlCGKotFyFEEl7","bracket":"_2ggnC0qUMig0e3pwgGd1oG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TheFormula/styles.css
// module id = 320
// module chunks = 0